import React, { useState, useEffect } from "react";
import "../css/toast.scss";

const SuccessIcon = () => (
  <svg
    className="toast-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
);

const ErrorIcon = () => (
  <svg
    className="toast-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </svg>
);

const Toast = ({ message, type, onClose, isCollapsed }) => {
  const [isVisible, setIsVisible] = useState(false);
  const messageStr =
    typeof message === "object"
      ? JSON.stringify(message)
      : String(message || "");

  useEffect(() => {
    if (messageStr) {
      console.log("[NotificationToast] messageStr:", messageStr);
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 3000);

      const closeTimer = setTimeout(() => {
        onClose();
      }, 3000 + 400);

      return () => {
        clearTimeout(timer);
        clearTimeout(closeTimer);
      };
    }
  }, [messageStr, onClose]);

  if (!messageStr) {
    return null;
  }

  const Icon = type === "success" ? SuccessIcon : ErrorIcon;

  const outerStyle = {
    zIndex: 2147483647,
    pointerEvents: isVisible ? "auto" : "none",
  };
  const contentStyle = {
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(-100%)",
  };

  console.log("[NotificationToast] render visible=", isVisible);

  return (
    <div
      className={`toast-notification ${isVisible ? "show" : ""}`}
      style={outerStyle}
    >
      <div className={`toast-content ${type}`} style={contentStyle}>
        <div className="toast-body">
          <Icon />
          <p>{messageStr}</p>
        </div>
      </div>
    </div>
  );
};

export default Toast;
